/* istanbul ignore file */
import React, { ReactNode } from 'react';
import { useArtifactService } from 'domain/shared/artifact';
import { Permission } from 'framework/authorization';
import TmpAccessAwareSecurityContext, { Service } from 'infrastructure/security/TmpAccessAwareSecurityContext';

const ARTIFACT_CONTEXT = 'Artifact';

interface ArtifactContextProps {
  permissionToCheck: Permission | Permission[];
  children: ReactNode;
  idSource?: string;
}

const ArtifactContext: React.FC<ArtifactContextProps> = ({
  permissionToCheck = null,
  children,
  idSource = undefined,
}) => {
  return (
    <TmpAccessAwareSecurityContext
      useEntityService={useArtifactService as unknown as () => Service}
      permissionToCheck={permissionToCheck}
      idSource={idSource}
      contextName={ARTIFACT_CONTEXT}
    >
      {children}
    </TmpAccessAwareSecurityContext>
  );
};

export default ArtifactContext;
